class productGalleryImages extends HTMLElement {
    constructor() {
        super();

        this.productSingleGallery = document.querySelector('[data-product-single-gallery]');
        var slidesPerView = 1.6;
        if(this.productSingleGallery.closest('.pdp-kids-beauty')) {
            slidesPerView = 1.2;
        }

        this.productSingleGallerySwiper = new Swiper(productSingleGallery, {
            loop: true,
            spaceBetween: 0,
            slidesPerView: slidesPerView,
            watchSlidesProgress: true,
            preloadImages: false,
            preventClicks: true,
            preventClicksPropagation: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                bulletElement: 'button'
            },
            breakpoints: {
                989: {
                    slidesPerView: 1,
                }
            }
        });

        this.productGallery();
        accessibilityHelpers.bindA11yToSwiper(this.productSingleGallerySwiper);
        
    }

    playPauseVideo(){
        let activeSlide = productSingleGallery.querySelector('.swiper-slide-active');
        let activeSlideVideo = activeSlide.querySelector('video');
        let slideVideos = productSingleGallery.querySelectorAll('video');
        if(activeSlideVideo){
            activeSlideVideo.play();
            activeSlideVideo.muted = true;
        } else{
            slideVideos.forEach(video => {
                video.pause();
            });
        }
    }

    productGallery(){
        let productSingleThumbnailsWrap = document.querySelector('[data-product-single-thumbnails]');
        let productSingleThumbnails = document.querySelectorAll('[data-product-single-thumbnail]');
        let productGalleryArrowNext = document.querySelector('.product-single__thumbnails-arrow.arrow-next');
        let productGalleryArrowPrev = document.querySelector('.product-single__thumbnails-arrow.arrow-prev');
        let productSingleGallery = document.querySelector('[data-product-single-gallery]');

        this.productSingleGallerySwiper.on('slideChange', function () {
            let activeIndex = this.activeIndex
            productSingleThumbnails.forEach(trigger => {
                if(trigger.dataset.slideIndex == activeIndex){
                    trigger.classList.add('is--active');
                    trigger.querySelector('button').setAttribute('aria-current', 'true');
                    let scrollAmount = trigger.offsetLeft - productSingleThumbnailsWrap.offsetLeft;
                    productSingleThumbnailsWrap.scrollTo({left: scrollAmount, behavior: 'smooth'});
                    //  productSingleThumbnailsWrap.scrollLeft = trigger.offsetLeft;
                } else{
                    trigger.classList.remove('is--active');
                    trigger.querySelector('button').removeAttribute('aria-current');
                }
            })
        });

        this.productSingleGallerySwiper.on('slideChangeTransitionEnd', function () {
            let lastSlide = productSingleGallery.querySelector('li:last-of-type');
            let activeSlide = productSingleGallery.querySelector('.swiper-slide-active');
            let activeSlideVideo = activeSlide.querySelector('video');
            let slideVideos = productSingleGallery.querySelectorAll('video');
            if(activeSlideVideo){
                activeSlideVideo.muted = true;
                activeSlideVideo.play();
                if(!activeSlideVideo.paused) {
                    const playButton = activeSlide.querySelector('.video-overlay svg');
                    if(playButton) playButton.style.display = 'none';
                }
            } else{
                slideVideos.forEach(video => {
                    if(!video.paused) {
                        video.pause();
                        const playButton = video.closest('.product-single__media').querySelector('.video-overlay svg');
                        if(playButton) playButton.style.display = '';
                    }
                });
            }

        });
        

        productSingleThumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", (e) =>{
                let clickedThumbnail = e.target.closest('[data-product-single-thumbnail]');
                let slideIndex = clickedThumbnail.dataset.slideIndex;
                // productSingleGallerySwiper.slideTo(slideIndex, 500, false);
                this.updateActiveImage(slideIndex);
                this.playPauseVideo();
            });
        });

        if(productGalleryArrowNext){
            productGalleryArrowNext.addEventListener('click', () => {
                let currentSlide = productSingleThumbnailsWrap.querySelector('li.is--active')
                let nextSlide = currentSlide.nextSibling;
                let firstSlide = productSingleThumbnailsWrap.querySelector('li.thumbnail__catalogue-image[data-slide-index="1"]')
                if (nextSlide) {
                    let nextSlideIndex = nextSlide.dataset.slideIndex;
                    productSingleThumbnailsWrap.scrollTo({top: nextSlide.offsetTop, behavior: 'smooth'});
                    this.updateActiveImage(nextSlideIndex)
                }else{
                    let firstSlideIndex = firstSlide.dataset.slideIndex;
                    productSingleThumbnailsWrap.scrollTo({top: firstSlide.offsetTop});
                    this.updateActiveImage(firstSlideIndex)
                }
                this.playPauseVideo();
            })
        }
        if(productGalleryArrowPrev){
            productGalleryArrowPrev.addEventListener('click', () => {
                let currentSlide = productSingleThumbnailsWrap.querySelector('li.is--active')
                let prevSlide = currentSlide.previousSibling;
                if (prevSlide) {
                    let prevSlideIndex = prevSlide.dataset.slideIndex;
                    productSingleThumbnailsWrap.scrollTo({top: prevSlide.offsetTop, behavior: 'smooth'});
                    this.updateActiveImage(prevSlideIndex)
                }
                this.playPauseVideo();
            })
        }

    }

    updateActiveImage(index){
        this.productSingleGallerySwiper.slideTo(index, 0, false);
    }
}

customElements.define('product-gallery-images', productGalleryImages);